import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="9tl7ct61zbs7">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-line bg-panel p-8 shadow-card sm:p-12" data-id="element-96" data-mp="et6735t1ro5z">
          <span className="inline-flex rounded-full bg-sage p-4 text-forestDeep" data-id="element-97" data-mp="skcc1hf3ie09">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xjxjyhc8twp4" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-99" data-mp="xlrvx65jeeh2">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-100" data-mp="17hbslurxdh6v">
            Open all 9 volumes. Review all 5 bonuses. Use them in your most challenging wine studies class this week. If
            you feel your students didn&apos;t respond better or the materials didn&apos;t save you hours of work:
          </p>
          <p className="mt-6 rounded-lg bg-sageSoft px-5 py-4 text-lg font-extrabold text-forestSoft" data-id="element-101" data-mp="1vusjedgo2gdf">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-102" data-mp="2ohdcbicsj0j3">
            Because if this teacher ready doesn&apos;t deliver the value we promise, we don&apos;t want to keep your
            money.
          </p>
        </motion.div>
      </div>
    </section>;
}